import { createSlice } from "@reduxjs/toolkit";
import { LoadState } from "../../constants/enums";
import { initialRequestedUserNameState } from "./requestedUserName.types";
import {
  fetchRequestedUserNameList,
  updateRequestedUserNameStatus,
} from "./requestedUserNameThunk";
import { APIError } from "../../constants/types";

const requestedUserNameSlice = createSlice({
  name: "requestedUserName",
  initialState: initialRequestedUserNameState,
  reducers: {
    clearRequestedUserNameState: () => {
      return initialRequestedUserNameState;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch list
      .addCase(fetchRequestedUserNameList.pending, (state) => {
        state.loading = LoadState.InProgress;
        state.list = [];
        state.totalRecords = 0;
      })
      .addCase(fetchRequestedUserNameList.fulfilled, (state, action) => {
        state.loading = LoadState.Loaded;
        state.list = action.payload.data;
        state.totalRecords = action.payload.totalRecords;
      })
      .addCase(fetchRequestedUserNameList.rejected, (state, action) => {
        state.loading = LoadState.Failed;
        state.error = (action.payload as APIError).message;
      })
      // Update status
      .addCase(updateRequestedUserNameStatus.pending, (state) => {
        state.statusUpdateLoading = LoadState.InProgress;
      })
      .addCase(updateRequestedUserNameStatus.fulfilled, (state) => {
        state.statusUpdateLoading = LoadState.Loaded;
      })
      .addCase(updateRequestedUserNameStatus.rejected, (state, action) => {
        state.statusUpdateLoading = LoadState.Failed;
        state.error = (action.payload as APIError).message;
      });
  },
});

export const { clearRequestedUserNameState } = requestedUserNameSlice.actions;

export const requestedUserNameReducer = requestedUserNameSlice.reducer;
